import React from 'react';
import {
  Compass,
  FileSearch,
  FileText,
  FolderOpen,
  GitBranch,
  ListChecks,
  Network,
  Quote,
  Route,
  Search,
  Settings,
  TriangleAlert,
  Workflow,
} from 'lucide-react';

const h = React.createElement;

const LOCAL_ICON_COMPONENTS = new Map([
  ['compass', Compass],
  ['file-search', FileSearch],
  ['file-text', FileText],
  ['folder-open', FolderOpen],
  ['git-branch', GitBranch],
  ['list-checks', ListChecks],
  ['network', Network],
  ['quote', Quote],
  ['route', Route],
  ['search', Search],
  ['settings', Settings],
  ['triangle-alert', TriangleAlert],
  ['workflow', Workflow],
]);

function renderProcessIcon(iconClass) {
  const IconComponent = LOCAL_ICON_COMPONENTS.get(iconClass) || Network;
  return h(IconComponent, {
    'aria-hidden': 'true',
    className: 'flare-system-process-icon',
    size: 12,
    strokeWidth: 1.8,
  });
}

export const WORKFLOW_STATUS_LABELS = {
  not_started: '未开始',
  queued: '排队中',
  running: '进行中',
  waiting_user: '等待你回答',
  succeeded: '已完成',
  failed: '失败',
  partial: '部分完成',
  cancelled: '已取消',
  blocked: '阻塞',
};

export function resolveCategoryIconClass(category = '') {
  const normalized = String(category || '').trim().toLowerCase();
  const iconByCategory = new Map([
    ['routing', 'route'],
    ['execution', 'settings'],
    ['capability', 'search'],
    ['workspace', 'folder-open'],
    ['fields', 'list-checks'],
    ['blocking', 'triangle-alert'],
    ['decision', 'workflow'],
  ]);
  return iconByCategory.get(normalized) ?? 'network';
}

export function resolveActionIconClass(action = '', fallbackCategory = '') {
  const normalized = String(action || '').trim().toLowerCase();
  const iconRules = [
    { terms: ['knowledge_search', 'search'], icon: 'file-search' },
    { terms: ['knowledge_citation', 'citation'], icon: 'quote' },
    { terms: ['mode_switch', 'routing'], icon: 'compass' },
    { terms: ['stage', 'decision'], icon: 'git-branch' },
    { terms: ['analysis_payload'], icon: 'file-text' },
  ];
  return iconRules.find(({ terms }) => terms.some((term) => normalized.includes(term)))?.icon
    ?? resolveCategoryIconClass(fallbackCategory);
}

export function ProcessSection({ title, iconClass, children }) {
  return h(
    'div',
    { className: 'flare-system-process-section' },
    h(
      'div',
      { className: 'flare-system-process-section-title' },
      renderProcessIcon(iconClass),
      h('strong', null, title)
    ),
    h('div', { className: 'flare-system-process-section-body' }, children)
  );
}

export function renderTraceLines(records = [], category = '') {
  return records.map((trace, index) => {
    const action = String(trace?.action || 'unknown').trim();
    const detail = String(trace?.detail || '').trim();
    return h(
      'div',
      {
        key: String(trace?.id || `${action}-${index}`),
        className: 'flare-system-process-action-row',
      },
      renderProcessIcon(resolveActionIconClass(action, category)),
      h('span', null, `${index + 1}. ${action}${detail ? ` · ${detail}` : ''}`)
    );
  });
}

export function resolveFieldKey(field) {
  return String(field?.field_key || field?.key || field?.field_label || '').trim();
}
